// import React from "react";
// import { Routes, Route } from "react-router-dom";

// //Layouts
// import NonAuthLayout from "../Layouts/NonAuthLayout";
// import VerticalLayout from "../Layouts/index";

// //routes
// import { authProtectedRoutes, publicRoutes } from "./allRoutes";
// import { AuthProtected } from "./AuthProtected";
// import {
//   checkAccessPermission,
//   commonAccessChecker,
// } from "../Utils/CommonUtils";
// import { useSelector } from "react-redux";

// const Index = () => {
//   const data = useSelector((state) => state.sidebar);

//   return (
//     <React.Fragment>
//       <Routes>
//         <Route>
//           {publicRoutes.map((route, idx) => (
//             <Route
//               path={route.path}
//               element={<NonAuthLayout>{route.component}</NonAuthLayout>}
//               key={idx}
//               exact={true}
//             />
//           ))}
//         </Route>

//         {authProtectedRoutes.map((route, idx) => (
//           <Route
//             key={idx}
//             path={route.path}
//             element={
//               <AuthProtected>
//                 {/* {checkAccessPermission(route.actionType, route.moduleCode) ? ( */}
//                 <VerticalLayout>{route.component}</VerticalLayout>
//                 {/* ) : (
//                   <div>Access Denied</div>
//                 )} */}
//               </AuthProtected>
//             }
//           />
//         ))}
//       </Routes>
//     </React.Fragment>
//   );
// };

// export default Index;

// Routing.js
import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import NonAuthLayout from "../Layouts/NonAuthLayout";
import VerticalLayout from "../Layouts/index";
import { authProtectedRoutes, publicRoutes } from "./allRoutes";
import { AuthProtected } from "./AuthProtected";
import { useSelector } from "react-redux";
import { checkAccessPermission } from "../Utils/CommonUtils";

const ProtectedRoute = ({ element, actionType, moduleCode }) => {
  const accessData = useSelector((state) => state.sidebar);


  const hasPermission = accessData
    ? checkAccessPermission(actionType, moduleCode, accessData)
    : false;

  return hasPermission ? element : null;
};

const Routing = () => {
  return (
    <Routes>
      {/* Public Routes */}
      {publicRoutes.map((route, idx) => (
        <Route
          key={idx}
          path={route.path}
          element={<NonAuthLayout>{route.component}</NonAuthLayout>}
        />
      ))}

      {/* Auth Protected Routes */}
      {authProtectedRoutes.map((route, idx) => (
        <Route
          key={idx}
          path={route.path}
          element={
            <AuthProtected>
              <VerticalLayout>
                <ProtectedRoute
                  element={route.component}
                  actionType={route.actionType}
                  moduleCode={route.moduleCode}
                />
              </VerticalLayout>
            </AuthProtected>
          }
        />
      ))}

      {/* Redirects */}
      <Route path="/" element={<Navigate to="/dashboard" />} />
      <Route path="*" element={<Navigate to="/hub/information" />} />
    </Routes>
  );
};

export default Routing;
